import dashboard1 from "../../../assets/images/analytics/interativeImages/analytics_ko/Data_insight_1-1.svg"
import dashboard2 from "../../../assets/images/analytics/interativeImages/analytics_ko/Data_insight_1-2.svg"
import dashboard3 from "../../../assets/images/analytics/interativeImages/analytics_ko/Data_insight_1-3.svg"
import dashboard4 from "../../../assets/images/analytics/interativeImages/analytics_ko/Data_insight_2-1.svg"
import dashboard5 from "../../../assets/images/analytics/interativeImages/analytics_ko/Data_insight_2-2.svg"
import dashboard6 from "../../../assets/images/analytics/interativeImages/analytics_ko/Data_insight_3-1.svg"
import dashboard7 from "../../../assets/images/analytics/interativeImages/analytics_ko/Data_insight_3-2.svg"
import dashboard8 from "../../../assets/images/analytics/interativeImages/analytics_ko/Data_insight_3-3.svg"
import dashboard9 from "../../../assets/images/analytics/interativeImages/analytics_ko/Data_insight_3-4.svg"
import dashboard1Mo from "../../../assets/images/analytics/interativeImages/analytics_ko_mo/Data_insight_mo_1-1.svg"
import dashboard2Mo from "../../../assets/images/analytics/interativeImages/analytics_ko_mo/Data_insight_mo_1-2.svg"
import dashboard3Mo from "../../../assets/images/analytics/interativeImages/analytics_ko_mo/Data_insight_mo_1-3.svg"
import dashboard4Mo from "../../../assets/images/analytics/interativeImages/analytics_ko_mo/Data_insight_mo_2-1.svg"
import dashboard5Mo from "../../../assets/images/analytics/interativeImages/analytics_ko_mo/Data_insight_mo_2-2.svg"
import dashboard6Mo from "../../../assets/images/analytics/interativeImages/analytics_ko_mo/Data_insight_mo_3-1.svg"
import dashboard7Mo from "../../../assets/images/analytics/interativeImages/analytics_ko_mo/Data_insight_mo_3-2.svg"
import dashboard8Mo from "../../../assets/images/analytics/interativeImages/analytics_ko_mo/Data_insight_mo_3-3.svg"
import dashboard9Mo from "../../../assets/images/analytics/interativeImages/analytics_ko_mo/Data_insight_mo_3-4.svg"

import dashboard1En from "../../../assets/images/analytics/interativeImages/analytics_en/Data_insight_en_1-1.svg"
import dashboard2En from "../../../assets/images/analytics/interativeImages/analytics_en/Data_insight_en_1-2.svg"
import dashboard3En from "../../../assets/images/analytics/interativeImages/analytics_en/Data_insight_en_1-3.svg"
import dashboard4En from "../../../assets/images/analytics/interativeImages/analytics_en/Data_insight_en_2-1.svg"
import dashboard5En from "../../../assets/images/analytics/interativeImages/analytics_en/Data_insight_en_2-2.svg"
import dashboard6En from "../../../assets/images/analytics/interativeImages/analytics_en/Data_insight_en_3-1.svg"
import dashboard7En from "../../../assets/images/analytics/interativeImages/analytics_en/Data_insight_en_3-2.svg"
import dashboard8En from "../../../assets/images/analytics/interativeImages/analytics_en/Data_insight_en_3-3.svg"
import dashboard9En from "../../../assets/images/analytics/interativeImages/analytics_en/Data_insight_en_3-4.svg"
import dashboard1EnMo from "../../../assets/images/analytics/interativeImages/analytics_en_mo/Data_insight_en_mo_1-1.svg"
import dashboard2EnMo from "../../../assets/images/analytics/interativeImages/analytics_en_mo/Data_insight_en_mo_1-2.svg"
import dashboard3EnMo from "../../../assets/images/analytics/interativeImages/analytics_en_mo/Data_insight_en_mo_1-3.svg"
import dashboard4EnMo from "../../../assets/images/analytics/interativeImages/analytics_en_mo/Data_insight_en_mo_2-1.svg"
import dashboard5EnMo from "../../../assets/images/analytics/interativeImages/analytics_en_mo/Data_insight_en_mo_2-2.svg"
import dashboard6EnMo from "../../../assets/images/analytics/interativeImages/analytics_en_mo/Data_insight_en_mo_3-1.svg"
import dashboard7EnMo from "../../../assets/images/analytics/interativeImages/analytics_en_mo/Data_insight_en_mo_3-2.svg"
import dashboard8EnMo from "../../../assets/images/analytics/interativeImages/analytics_en_mo/Data_insight_en_mo_3-3.svg"
import dashboard9EnMo from "../../../assets/images/analytics/interativeImages/analytics_en_mo/Data_insight_en_mo_3-3.svg"
import usePlatform from "../../../hooks/usePlatform"
import { Locale } from "../../../locale"
import React, { useEffect, useRef, useState } from "react"
import { Grid } from "@material-ui/core"
import { createStyles, makeStyles } from "@material-ui/core/styles"
import classNames from "classnames"
import { keyframes } from "@emotion/react"
import { setInterval } from "timers"

const images = [
  dashboard1,
  dashboard2,
  dashboard3,
  dashboard4,
  dashboard5,
  dashboard6,
  dashboard7,
  dashboard8,
  dashboard9,
]
const mobileImages = [
  dashboard1Mo,
  dashboard2Mo,
  dashboard3Mo,
  dashboard4Mo,
  dashboard5Mo,
  dashboard6Mo,
  dashboard7Mo,
  dashboard8Mo,
  dashboard9Mo,
]
const enImages = [
  dashboard1En,
  dashboard2En,
  dashboard3En,
  dashboard4En,
  dashboard5En,
  dashboard6En,
  dashboard7En,
  dashboard8En,
  dashboard9En,
]
const enMobileImages = [
  dashboard1EnMo,
  dashboard2EnMo,
  dashboard3EnMo,
  dashboard4EnMo,
  dashboard5EnMo,
  dashboard6EnMo,
  dashboard7EnMo,
  dashboard8EnMo,
  dashboard9EnMo,
]

const transition = keyframes`
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`

const useStyles = makeStyles((theme) =>
  createStyles({
    imageWrapper: {
      position: "absolute",
      width: "100%",
      marginTop: 32,
      "& img": {
        width: "100%",
      },
      [theme.breakpoints.up("md")]: {
        marginTop: 72,
      },
    },
    fadeIn: {
      opacity: 1,
    },
    fadeOut: {
      opacity: 0,
    },
    animated: {
      transition: `${transition} 1s infinite`,
    },
  })
)

export default function TransitionDashboardImages() {
  const classes = useStyles()
  const { isMobile } = usePlatform()
  const { lang } = Locale.getDefault()
  const [index, setIndex] = useState(0)
  const imgRef = useRef<HTMLImageElement>(null)
  const lastIndex = images.length - 1

  const getImageSrc = () => {
    if (lang === "ko") {
      return isMobile ? mobileImages[index] : images[index]
    }
    return isMobile ? enMobileImages[index] : enImages[index]
  }

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prevIndex) => (prevIndex === lastIndex ? 0 : prevIndex + 1))
    }, 1000)

    return () => {
      clearInterval(timer)
    }
  }, [])

  return (
    <Grid item className={classNames(classes.imageWrapper, classes.animated)} id={"wrapper"}>
      <img src={getImageSrc()} alt={"Data Analytics"} ref={imgRef} />
    </Grid>
  )
}
